import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./pages/Layout";
import Home from "./pages/Home/Home";
import Reviewers from "./pages/Reviewers/Reviewers";
import Syntube from "./pages/Syntube/Syntube";
import Tutorials from "./pages/Tutorials";
import NotFound from "./pages/NotFound";

import Admin from "./pages/Admin/Admin"
import AdminReviewers from "./pages/Admin/AdminReviewers"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* HOME PAGE */}
        <Route index element={<Home />} />
        
        {/* PAGES WITH LAYOUT */}
        <Route path="/" element={<Layout />}>
          <Route path="reviewers" element={<Reviewers />} />
          <Route path="syntube" element={<Syntube />} />
          <Route path="tutorials" element={<Tutorials />} />
          {/* PAGE NOT FOUND */}
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* ADMIN ROUTES */}
        <Route path="/admin">
          <Route path="" element={<Admin />} />
          <Route path="reviewers" element={<AdminReviewers />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
